<template>
  <div id="project-news">
    <div class="project-box">
      <div class="time-box">
        <ul>
          <li
            v-for="(item,index) in yearList"
            :key="index"
            :class="{active:timeStatus==index}"
            @click="getList(index,item)"
          >{{item}}</li>
        </ul>
      </div>
      <div class="project-bottom">
        <ul>
          <li v-for="(item,index) in dataList.data" :key="index" :title="item.news_title">
            <div class="project-col">
              <div class="img-box">
                <viewer :images="item.imgs" style="display:inline-block;">
                  <img
                    v-for="(val,key) in item.imgs"
                    :key="key"
                    :src="val"
                    v-show="key==0"
                    :alt="item.news_title"
                    style="width:310px;height:260px"
                  />
                </viewer>
              </div>
              <div class="content-box">
                <h5>{{item.news_title}}</h5>
                <span>{{item.custom_time}}</span>
                <!-- &#xe60d; -->
                <i class="iconfont" v-if="item.pic_ids && item.pic_ids.length > 0"><span style="color: #999;font-size: 14px;">{{item.pic_ids.length}}图</span></i>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div class="page-box" v-if="dataList.total > $db.config.newsListSize2">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page.sync="dataList.current_page"
          :page-size="$db.config.newsListSize2"
          :total="dataList.total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["chid", "type"],
  data() {
    return {
      yearList: [],
      year: null,
      timeStatus: 0,
      classShow: true,
      classHide: false,
      dataList: []
    };
  },
  mounted() {
    this.getYaer();
  },
  methods: {
    //改变页码
    handleCurrentChange(val) {
      this.getList(this.timeStatus, this.year, val);
    },
    getYaer() {
      //获取列表信息
      this.$db
        .post(this.$db.config.getDataByChidUrl, {
          id: this.chid
        })
        .then(res => {
          if (res && res.code == 200) {
            this.yearList = res.data;

            if (res.data && res.data.length > 0) {
              this.getList(0, res.data[0], 1);
            }
          }
        });
    },

    //根据年份获取图集列表
    getList(id = 0, year, page = 1) {
      this.year = year;
      this.timeStatus = id;
      //获取列表信息
      this.$db
        .post(this.$db.config.getPhotosByYear, {
          channel_id: this.chid,
          year: year,
          page_size: this.$db.config.newsListSize2,
          page: page
        })
        .then(res => {
          if (res && res.code == 200) {
            res.data.data.forEach(item => {
              item.imgs = [];
              if (item.news_pic_url && item.news_pic_url != "") {
                // item.imgs.push(item.news_pic_url);
              } else {
                //默认图片
              }
              if (item.pic_ids_path && item.pic_ids_path.length > 0) {
                item.pic_ids_path.forEach(val => {
                  item.imgs.push(val.url);
                });
              }
            });

            this.dataList = res.data;
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped>
#app-project {
  width: 100%;
  margin: 20px 0;
  margin-top: 0;
}
.project-box {
  width: 1300px;
  margin: 0 auto;
  padding: 30px 0;
  .time-box {
    > ul {
      margin-top: 18px;
      margin-bottom: 38px;
      display: flex;
      flex-wrap: wrap;
      > li {
        padding: 0 18px;
        height: 33px;
        background-color: #ffffff;
        border-radius: 18px;
        border: solid 1px #cccccc;
        line-height: 33px;
        color: #999999;
        font-size: 16px;
        margin-right: 20px;
        cursor: pointer;
        &.active {
          border-color: #c30d23;
          color: #c30d23;
        }
      }
    }
  }
  .project-top {
    position: relative;
    margin-bottom: 60px;
    > h3 {
      font-size: 30px;
      color: #000;
      font-weight: normal;
      padding: 14px 0;
    }
    .more-box {
      position: absolute;
      right: 0;
      top: 20px;
      > p {
        font-size: 12px;
        color: #333333;
      }
      > h6 {
        font-size: 14px;
        color: #333333;
      }
    }
    .border-box {
      width: 1300px;
      height: 1px;
      border: 1px solid #c30d23;
      border-bottom: 3px solid #c30d23;
    }
  }
  .project-bottom {
    > ul {
      display: flex;
      flex-wrap: wrap;
      > li {
        width: 310px;
        margin-right: 20px;
        &:nth-child(4n) {
          margin-right: 0;
        }
        .project-col {
          cursor: pointer;
          margin-bottom: 26px;
          transition: ease-out 0.6s;
          &:hover {
            transform: scale(1.05);
            box-shadow: 0px 0px 35px 0px rgba(9, 1, 4, 0.21);
            .content-box {
              background-color: #c30d23;
              transition: all 1.5s;
              > h5 {
                color: #fff;
              }
              > span {
                color: #fff;
              }
              > i {
                color: #fff;
              }
            }
          }
          .img-box {
            width: 100%;
            height: 260px;
            > img {
              width: 100%;
              height: 100%;
            }
          }
          .content-box {
            padding: 20px 24px 20px 9px;
            position: relative;
            > h5 {
              font-size: 18px;
              color: #333;
              font-weight: 500;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            > span {
              display: block;
              color: #999999;
              font-size: 14px;
              margin-top: 16px;
            }
            > i {
              font-style: normal;
              position: absolute;
              bottom: 20px;
              right: 20px;
              font-size: 22px;
            }
            > ul {
              > li {
                list-style: none;
                margin-top: 6px;
                > span {
                  font-size: 14px;
                  color: #999;
                }
                > i {
                  font-style: normal;
                  font-size: 16px;
                  color: #c30d23;
                  font-weight: 700;
                }
                > b {
                  font-size: 16px;
                  // font-weight: normal;
                  color: #333;
                }
              }
            }
          }
        }
      }
    }
  }

  .page-box {
    text-align: center;
    margin-bottom: 70px;
  }

  .page-box
    /deep/
    .el-pagination.is-background
    .el-pager
    li:not(.disabled).active {
    background-color: #c30d23;
    color: #fff;
  }
  .page-box /deep/ .el-pagination.is-background .el-pager li {
    background-color: #fff;
    border: solid 1px #dddddd;
    color: #999;
  }
  .page-box
    /deep/
    .el-pagination.is-background
    .el-pager
    li:not(.disabled):hover {
    color: #c30d23;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Public/photos.vue